import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useRemoteClientPost } from '../../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../../remote/catch-message-error'
import { useToast } from '../../../../../hooks'
import { serviceForm, serviceSchema } from '../../../../../validators/services-validator'

export const CreateService = () => {
  const { httpClientPost } = useRemoteClientPost()
  const { showToast } = useToast()
  const form = useForm<serviceForm>({
    resolver: zodResolver(serviceSchema)
  })

  const onSubmit = async (data: serviceForm) => {
    try {
      await httpClientPost('/servicos', data)
      form.reset()
      form.setValue('id', 0)
      form.setValue('nome', '')
      form.setValue('observacao', '')
      form.setValue('valor', 0)
      showToast('Servico criado com sucesso', 'success')
    } catch (error) {
      CatchMessageError(error)
    }
  }

  return {
    form,
    onSubmit
  }
}
